import { ArrowDownToLine, FileChartColumnIncreasing, Upload } from "lucide-react";

export const DOCUMENT_TYPE = "documentTypeId";
export const HEADER = "header";
export const LINE_ITEM = "lineItems";
export const INVOICES = "invoices";

export const tabs = [
  {
    label: "Manual Entry",
    value: "manual"
  },
  {
    label: "Download Excel Template",
    value: "download"
  },
  {
    label: "Upload Excel",
    value: "upload"
  }
]

export const actionItems = [
  {
    title: "1. Manual Entry",
    desc: "Post a direct journal entry using configured header and line item fields.",
    icon: FileChartColumnIncreasing,
  },
  {
    title: "2. Download Template",
    desc: "Download a document-type-specific template with header and line items.",
    icon: ArrowDownToLine,
  },
  {
    title: "3. Upload Excel",
    desc: "Upload a document-type-specific template with header and line items.",
    icon: Upload,
  }
];
